export enum CountryZipCode {
  US = 230,
  UK = 229,
  Canada = 38
}

export class ZipCodeValidator {

  isValid(countryCode: CountryZipCode, val: string) {
    switch (countryCode) {
      case CountryZipCode.US:
        return this.validateUSZipCode(val);
      case CountryZipCode.UK:
        return this.validateUKZipCode(val);
      case CountryZipCode.US:
        return this.validateCanadaZipCode(val);
      default:
        return true;
    }

  }

  private validateUSZipCode(val) {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(val);
  }

  private validateUKZipCode(val) {
    return /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i.test(val);
  }

  private validateCanadaZipCode(val) {
    return /[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/.test(val);
  }
}
